import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Demande } from '../../interfaces/demande.interface';

@Injectable()
export class DemandeService {

    private url = `${environment.api}/demande/`;
    constructor(private http: HttpClient) { }

    save(demande: Demande): Observable<any> {
        return this.http.post<any>(`${this.url}`, demande);
    }

    update(demande: Demande): Observable<any> {
        return this.http.put<any>(`${this.url}`, demande);
    }

    delete(primaryKey: any): Observable<any> {
        return this.http.delete<any>(`${this.url}/${encodeURI(JSON.stringify(primaryKey))}`, );
    }

    query(queryParameter: any): Observable<any[]> {
        return this.http.get<any[]>(`${environment.api}/demande/query/${encodeURI(JSON.stringify(queryParameter))}`);
    }

    aggregate(param: any): Observable<any[]> {
        return this.http.get<any[]>(`${environment.api}/demande/aggregate/${encodeURI(JSON.stringify(param))}`);
    }
    // Trouve un seul enregistrements de TypeEntity
    findOne(primaryKey: any): Observable<any> {
        return this.http.get<any>(`${environment.api}/demande/${encodeURI(JSON.stringify(primaryKey))}`);
    }
}
